import React from 'react'
import echarts from 'echarts'
import "./HomePageStatistics.scss"
import {chartData,statisticslist,bindingcategory} from "../../api/index"
import { NavBar,Icon,Tabs,Calendar,Drawer,Toast  } from 'antd-mobile';
import MyTabs  from '../../components/myTabs/myTabs'
import tc1 from '../../public/image/tc1.png'
import tc2 from '../../public/image/tc2.png'
import {MyTable,MyTableHead,MyTableTr,MyTableTh,MyTableTd,MyTableBody} from '../../components/table/index'
import {getDay,getMonthStartDateAndDateRange,getOneDay,_dateFormatMySelf} from '../../utils/index'
export default class HomePageStatistics extends React.Component{
    constructor(props){
        super(props)
        this.state={
            activeLi:1,
            datas:{},
            chartData1:[],
            chartData2:[],
            showType:false,
            showDate:false,
            typeArr:[
                {
                name: "全部",
                id: 0
                },
                {
                    name: "工厂端",
                    id: 1
                },
                {
                    name: "影楼端",
                    id: 2
                },
                {
                    name: "平台端",
                    id: null
                }
            ],
            activeTypeInfo:{
                name: "全部",
                id: 0
            },
            DateArr:[
                {
                    name: "本月",
                    id: 3
                },
                {
                    name: "近十五天",
                    id: 5
                },
                {
                    name: "近七天",
                    id: 4
                },
                {
                    name: "今天",
                    id: 1
                },
                {
                    name: "选择日期",
                    id: null
                }
            ],
            activeDateInfo:{
                name: "近七天",
                id: 3
            },
            time:[getOneDay(-6), getOneDay(0)],
            type:null,
            zhuData:{},
            myChart1:null,
            myChart2:null,
            show:false,
            config: {},
            dataList: [
                {
				    date: getDay(0).date,
                    shortDay: getDay(0).shortDate,
                }, {
                    date: getDay(-1).date,
                    shortDay: getDay(-1).shortDate,
                }, {
                    date: getDay(-2).date,
                    shortDay: getDay(-2).shortDate,
                }, {
                    date: getDay(-3).date,
                    shortDay: getDay(-3).shortDate,
                }, {
                    date: getDay(-4).date,
                    shortDay: getDay(-4).shortDate,
                },{
                    date: getDay(-5).date,
                    shortDay: getDay(-5).shortDate,
                },{
                    date: getDay(-6).date,
                    shortDay: getDay(-6).shortDate,
                },{
                    date: getDay(-7).date,
                    shortDay: getDay(-7).shortDate,
                }, 
            ],
            Draweractiveli:getDay(0).date,
            Drawershow:false,
            listData:[],
            scxtype:"scx"
        }
        
    }
    changeLi(val){
        console.log("123")
        this.setState({
            activeLi:val
        })
        console.log(this.state.datas)
        if(val==1){
            this.setState({
                chartData1:[{
                    name: '影楼',
                    value:this.state.datas.todayStudioOrderQuantity,
                   
                },
                {
                    name: '工厂',
                    value:this.state.datas.todayFactoryOrderQuantity,
                    
                }],
                chartData2:[{
                    name: '影楼',
                    value:this.state.datas.todayStudioOrderAmount,
                    
                },
                {
                    name: '工厂',
                    value:this.state.datas.todayFactoryOrderAmount,
                   
                }]
            },()=>{
                this.chartsSet("myChart1",this.state.chartData1,this.state.datas.todayQuantity,'下单总本数')
                this.chartsSet("myChart2",this.state.chartData2,this.state.datas.todayAmount,'下单总金额')
            })
        }else if (val==2){
            this.setState({
                chartData1:[{
                    name: '影楼',
                    value:this.state.datas.yesterdayStudioOrderQuantity,
                   
                },
                {
                    name: '工厂',
                    value:this.state.datas.yesterdayFactoryOrderQuantity,
                    
                }],
                chartData2:[{
                    name: '影楼',
                    value:this.state.datas.yesterdayStudioOrderAmount,
                    
                },
                {
                    name: '工厂',
                    value:this.state.datas.yesterdayFactoryOrderAmount,
                   
                }]
            },()=>{
                this.chartsSet("myChart1",this.state.chartData1,this.state.datas.yesterdayQuantity,'下单总本数')
                this.chartsSet("myChart2",this.state.chartData2,this.state.datas.yesterdayAmount,'下单总金额')
            })
            
        }
        
    }
    chartsSet(id,data,num,text){
        let option = {
            // tooltip: {
            //     trigger: 'item',
            //     formatter: '{a} <br/>{b}: {c} ({d}%)'
            // },
            // legend: {
            //     orient: 'vertical',
            //     left: 10,
            //     data: data
            // },
            
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['80%', '100%'],
                    right:0,
                    left:0,
                    top:0,
                    bottom:0,
                    avoidLabelOverlap: false,
                    label: {
                        normal:{
                            show: true,
                            position: 'center',
                            formatter:function(){
                                return `${num}\r\n${text}`;
                            },
                            textStyle:{
                                color:"#333333"
                            }
                        }
                        
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: data
                }
            ],
            color:[ //自定义的颜色
                '#0486FE',
                '#FDAD02',
            ]
        };
        console.log(option);
        this.state[id].clear();
        this.state[id].setOption(option);
    }
    changeshow(type){
        if(type=='date'){
            this.setState({
                showType:false,
                showDate:!this.state.showDate,
            })
        }else{
            this.setState({
                showType:!this.state.showType,
                showDate:false,
            })
        }
        
    }
    async getZchartsDate(){
        console.log("this.state.activeTypeInfo...",this.state.activeTypeInfo)
        let obj={
            source:this.state.activeTypeInfo.id,
            endTime:_dateFormatMySelf(this.state.time[1]),
            startTime:_dateFormatMySelf(this.state.time[0]),
            type:this.state.type||""
        }
        if(obj.source==null){
            obj.isShare=1
        }
        let res=await chartData(obj);
        if(res.code==0){
            this.setState({
                zhuData:res.data
            })
            let barData = [],lineData = [],timeData = res.data.everyDays;
            res.data.everyDays.forEach((s) => {
                if (res.data.operatorOrder.some((item) => {
                        return item.dates == s
                    })) {
                    res.data.operatorOrder.forEach((s1) => {
                        if (s1.dates == s) {
                            barData.push(s1.totalAmount);
                            lineData.push(s1.totalQuantity);
                        }
                    })
                } else {
                    barData.push(0);
                    lineData.push(0);
                }

            })
            
            this.echar(barData, lineData, timeData);
        }else{
            Toast.fail(res.msg,3)
        }
    }
    async getTime(val){
        switch(val){
            case 3:
            this.setState({
                time:getMonthStartDateAndDateRange(),
                type:2
            })
            break;
            case 1:
                this.setState({
                    time:[new Date(), new Date()],
                    type:3
                })
            break;
            
            
            case 4:
                this.setState({
                    time:[getOneDay(-6), getOneDay(0)],
                    type:""
                })
                
                break;
            case 5:
                this.setState({
                    time:[getOneDay(-14), getOneDay(0)],
                    type:""
                })
                break;
            case null:
                return 'chose'
                break
        }
        
    }
    changeTime(val){
        this.setState({
            activeDateInfo:val
        },async ()=>{
            let res=await this.getTime(val.id);
            if(res=="chose"){
                this.setState({
                    show:true
                })
            }else if(val.id){
                this.getZchartsDate()
            }
        })
        this.setState({
            showDate:false
        })
    }
    changeType(val){
        this.setState({
            activeTypeInfo:val
        },()=>{
            this.getZchartsDate()
        })
        this.setState({
            showType:false
        })
        
    }
    getbasis(){
        switch(this.state.activeTypeInfo.id){
            case 0:
                return this.state.zhuData.totalQuantity
                break
            case 1:
                return this.state.zhuData.factoryTotalQuantity
                break
            case 2:
                return this.state.zhuData.studioTotalQuantity
                break
            case null:
                return this.state.zhuData.shareTotalQuantity
                break
            default:
                return this.state.zhuData.shareTotalQuantity
        }
        
    }
    getMoney(){
        switch(this.state.activeTypeInfo.id){
            case 0:
                return this.state.zhuData.totalAmount
                break
            case 1:
                return this.state.zhuData.factoryTotalAmount
                break
            case 2:
                return this.state.zhuData.studioTotalAmount
                break
            case null:
                return this.state.zhuData.shareTotalAmount
                break
            default:
                return this.state.zhuData.shareTotalAmount
        }
    }
    echar(barData, lineData, timeDatas) {
        // timeData.forEach((s)=>{
        //   let arr=s.split("-")
        //   s=arr[1]+"-"+arr[2]
        // })
        
        let timeData = timeDatas.map((s) => {
            let arr = s.split("-")
            s = arr[1] + "-" + arr[2]
            return s
        });
        console.log(barData, lineData, timeDatas)
        
        this.state.myChart.on('legendselectchanged', function(obj) {


        });
        var option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
                top: '20',
                // left: '80',
                right: '60',
                bottom: '30',
            },
            xAxis:[{
                type: 'category',
                data: timeData,
                axisLabel: {
                    show: true,
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid'
                    }
                },
                splitLine:{
                    show: false,
                },//去除网格线
            }] ,
            yAxis: [ //当有两个y轴时，设置两个{}{}来承载y轴的值
                {
                    type: 'value',
                    min: 0,
                    axisLabel: {
                        textStyle: {
                            fontSize: 14,
                            fontWeight: 'normal',
                        },
                    },
                    splitLine: {
                        show: false
                    }, //y轴网格线，一般都会隐藏，x轴亦是如此

                },
                {
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            fontSize: 14,
                            fontWeight: 'normal',
                        },
                    },
                    splitLine: {
                        show: false
                    },
                    // inverse: true,
                },
            ],


            series: [ //对应折线图和柱形图，进行数据加载
                {
                    name: '本',
                    type: 'bar',
                    data: lineData,
                    barWidth: '10',
                    barGap: "0",
                    barCategoryGap: '30%',
                    itemStyle: {
                        normal: {
                            // width: 1,
                            color: "#7ED321",
                            barBorderRadius: [10,10,0,0],
                        },
                        
                    },
                    // label:{
                    // 	show:true,
                    // 	position:'top'
                    // }
                },
                {
                    name: '元',
                    type: 'bar',
                    yAxisIndex: 1,
                    data: barData,
                    barWidth: '10',
                    smooth: true,
                    label: {
                        normal: {
                            show: false,
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: "#9014EE",
                            barBorderRadius: [10,10,0,0],
                            // lineStyle:{
                            //   width: 3,
                            // color:"#46C29C"
                            // }
                        },
                    },
                    // label:{
                    // 	show:true,
                    // 	position:'top'
                    // }
                },
            ],
            // dataZoom: [{
            //     type: 'slider',
            //     show: timeData.length > 8 ? true : false,
            //     xAxisIndex: [0],
            //     filterMode: 'filter',
            //     maxValueSpan: 8,
            //     startValue: 0,
            //     endValue: 8 - 1,
            //     zoomLock: true,
            //     showDetail: false,
            // }, ]
        };

        this.state.myChart.clear();
        this.state.myChart.setOption(option);
    }
    onCancel(){

    }
    onConfirm(val,val2){
        console.log(val,val2);
        this.setState({
            show:false,
            time:[_dateFormatMySelf(val),_dateFormatMySelf(val2)]
        },()=>{
            this.getZchartsDate()
        })
    }
    backClick(s){
        console.log(s);
        this.setState({
            scxtype:s.value
        },()=>{
            this.getTablelist()
        })
    }
    async getTablelist(){
        let obj={
            currentDay:this.state.Draweractiveli
        }
        if(this.state.scxtype=="scx"){
            let res=await bindingcategory(obj);
            if(res.code==0){
                this.setState({
                    listData:res.data
                })
                
            }else{
                Toast.fail(res.msg,3)
            }
        }
        if(this.state.scxtype=="dp"){
            let res=await statisticslist(obj);
            if(res.code==0){
                this.setState({
                    listData:res.data
                })
            }else{
                Toast.fail(res.msg,3)
            }
        }
    }
    changeDay(s){
        console.log(s)
        this.setState({
            Draweractiveli:s.date
        },()=>{
            this.getTablelist();
        })
    }
    render(){
        let tabsData=[
            {
                name:"生产线排名",
                value:"scx"
            },
            {
                name:"单品排名",
                value:"dp"
            }
        ]
        const now = new Date();
        const sidebar=(<div className="Drawer">
                            <div className="dataList">
                                <ul>
                                    {this.state.dataList.map((s)=>{
                                        return <li onClick={()=>{this.changeDay(s)}}  className={this.state.Draweractiveli==s.date?"activeLi":null} key={s.shortDay}>{s.shortDay}</li>
                                    })}
                                    
                                </ul>
                                <div className="tabsWrap">
                                    <MyTabs back={this.backClick.bind(this)}  data={tabsData}/>
                                </div>
                                <div className="tableWrap">
                                    <MyTable>
                                        <MyTableHead>
                                            <MyTableTh style={{width:'70px'}}>{"排名"}</MyTableTh>
                                            <MyTableTh>{"生产线"}</MyTableTh>
                                            <MyTableTh style={{width:'70px'}}>{"本数"}</MyTableTh>
                                        </MyTableHead>
                                        <MyTableBody>
                                        {this.state.listData.map((s,index)=>{
                                            return (
                                                <MyTableTr>
                                                    <MyTableTd>
                                                        <span>{index+1}</span>
                                                    </MyTableTd>
                                                    <MyTableTd>
                                                        <span>{s.name}</span>
                                                    </MyTableTd>
                                                    <MyTableTd>
                                                        <span>{s.cnt}</span>
                                                    </MyTableTd>
                                                </MyTableTr>
                                            )
                                        })}
                                        </MyTableBody>
                                    </MyTable>
                                </div>
                               
                            </div>
                       </div>)
        return (
            <div className="HomePageStatistics">
                <div className="topTabWrap">
                    <div className="TabWrap">
                        <ul>
                            <li className={this.state.activeLi==1?"activeLi":""} onClick={()=>{this.changeLi(1)}}>
                                今日下单
                                <div></div>
                            </li>
                            <li className={this.state.activeLi==2?"activeLi":""}  onClick={()=>{this.changeLi(2)}}>
                                昨日下单
                                <div></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="chartsWrap">
                    <div className="chartsWrapchildren">
                    <div style={{width:"58%",display:"inline-block"}}>
                            <canvas id="myChart1"  style={{width:"100%"}}></canvas>
                        </div>
                        <div className="chartsWrapLeft">
                            <div></div>
                            <div>
                                <span>影楼</span>
                                <p>
                                    <span className="money">
                                        {
                                            this.state.activeLi==1?
                                            this.state.datas.todayStudioOrderQuantity
                                            :this.state.datas.yesterdayStudioOrderQuantity
                                        }
                                    </span>
                                    <span  className="percent">
                                        {
                                            this.state.activeLi==1?
                                            (this.state.datas.todayQuantity?((this.state.datas.todayStudioOrderQuantity/this.state.datas.todayQuantity)*100).toFixed(2):0)+'%'
                                            :(this.state.datas.yesterdayQuantity?((this.state.datas.yesterdayStudioOrderQuantity/this.state.datas.yesterdayQuantity)*100).toFixed(2):0)+'%'
                                        }
                                    </span>
                                </p>
                            </div>
                            <div className="factory">
                                <span>工厂</span>
                                <p>
                                    <span className="money">
                                        {
                                            this.state.activeLi==1?
                                            this.state.datas.todayFactoryOrderQuantity:
                                            this.state.datas.yesterdayFactoryOrderQuantity
                                        }
                                    </span>
                                    <span className="percent">
                                        {
                                            this.state.activeLi==1?
                                            (this.state.datas.todayQuantity?((this.state.datas.todayFactoryOrderQuantity/this.state.datas.todayQuantity)*100).toFixed(2):0)+'%':
                                            (this.state.datas.yesterdayQuantity?((this.state.datas.yesterdayFactoryOrderQuantity/this.state.datas.yesterdayQuantity)*100).toFixed(2):0)+'%'
                                        }
                                    </span>
                                </p>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    <div className="chartsWrapchildren">
                        <div style={{width:"58%",display:"inline-block"}}>
                            <canvas id="myChart2"  style={{width:"100%"}}></canvas>
                        </div>
                        
                        <div className="chartsWrapLeft">
                            <div></div>
                            <div>
                                <span>影楼</span>
                                <p>
                                    <span className="money">
                                        {
                                            this.state.activeLi==1?
                                            this.state.datas.todayStudioOrderAmount:
                                            this.state.datas.yesterdayStudioOrderAmount
                                        }
                                    </span>
                                    <span  className="percent">
                                        {
                                            this.state.activeLi==1?
                                            (this.state.datas.todayAmount?((this.state.datas.todayStudioOrderAmount/this.state.datas.todayAmount)*100).toFixed(2):0)+'%'
                                            :(this.state.datas.yesterdayAmount?((this.state.datas.yesterdayStudioOrderAmount/this.state.datas.yesterdayAmount)*100).toFixed(2):0)+'%'
                                        }
                                    </span>
                                </p>
                            </div>
                            <div className="factory">
                                <span>工厂</span>
                                <p>
                                    <span className="money">
                                        {
                                            this.state.activeLi==1?
                                            this.state.datas.todayFactoryOrderAmount:
                                            this.state.datas.yesterdayFactoryOrderAmount
                                        }
                                    </span>
                                    <span className="percent">
                                        {
                                            this.state.activeLi==1?
                                            (this.state.datas.todayAmount?((this.state.datas.todayFactoryOrderAmount/this.state.datas.todayAmount)*100).toFixed(2):0)+'%'
                                            :(this.state.datas.yesterdayAmount?((this.state.datas.yesterdayFactoryOrderAmount/this.state.datas.yesterdayAmount)*100).toFixed(2):0)+'%'
                                        }
                                    </span>
                                </p>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>

                <div className="zhuChartsWrap">
                    <div className="title">查看数据</div>
                    <div className="selectDiv1">
                        <div className="selectType" onClick={()=>{
                                this.changeshow('type')
                            }}>
                            <span  className="selectTitle">{this.state.activeTypeInfo.name}</span>
                            <Icon  type="down"/>
                            {
                                this.state.showType?
                                <ul className="selectList" onClick={(e)=>{e.stopPropagation()}}>
                                    {this.state.typeArr.map((s)=>{
                                        return <li onClick={()=>{this.changeType(s)}} key={s.id}>{s.name}</li>
                                    })}
                                    
                                    
                                </ul>:null
                            }
                            
                        </div>
                        <div className="DateType" onClick={()=>{
                                this.changeshow('date')
                            }}>
                            <span  className="selectTitle">{this.state.activeDateInfo.id==null?
                            this.state.time[0]+"至"+this.state.time[1]:
                            this.state.activeDateInfo.name}</span>
                            <Icon  type="down"/>
                            {
                                this.state.showDate?
                                <ul className="selectList" onClick={(e)=>{e.stopPropagation()}}>
                                    {this.state.DateArr.map((s)=>{
                                        return <li onClick={()=>{this.changeTime(s)}}  key={s.id}>{s.name}</li>
                                    })}
                                </ul>:null
                            }
                        </div>
                    </div>
                    <div className="fkwrap">
                            <div className="fk">
                                <div>
                                    <div className="bendiv"></div>
                                    <span>{this.getbasis()+"(本)"}</span>
                                </div>
                                <div>
                                    <div className="yuandiv"></div>
                                    <span>{this.getMoney()+"(元)"}</span>
                                </div>
                            </div>
                    </div>
                    <div className="columnWrap">
                        <div id="mainCharts" style={{width: "100%",height:"47.2vw"}}></div>
                    </div>
                </div>
                <Calendar
                    visible={this.state.show}
                    onCancel={this.onCancel}
                    onConfirm={(startDate,endDate)=>{this.onConfirm(startDate,endDate)}}
                    
                    
                    defaultDate={now}
                    
                />
                <Drawer
                    className="my-drawer"
                    style={{ minHeight: document.documentElement.clientHeight }}
                    
                    contentStyle={{ color: '#A6A6A6', textAlign: 'center', paddingTop: 42 }}
                    sidebar={sidebar}
                    open={this.state.Drawershow}
                    
                    
                >
                </Drawer>
                <img  className="DrawerSwitch" src={!this.state.Drawershow?tc1:tc2} onClick={()=>{this.DrawerSwitch()}}/>
                {/* <div onClick={()=>{this.DrawerSwitch()}}></div> */}
            </div>
        )
    }
    DrawerSwitch(){
        let myd=document.getElementsByClassName("my-drawer")[0];
        
        if(this.state.Drawershow){
            
            myd.style['pointer-events']='none'
        }else{
            myd.style['pointer-events']='auto'
        }
        this.setState({Drawershow:!this.state.Drawershow})
    }
    
    async componentDidMount(){
        this.getTablelist()
        this.setState({
            myChart1:echarts.init(document.getElementById('myChart1')),
            myChart2:echarts.init(document.getElementById('myChart2')),
            myChart:echarts.init(document.getElementById('mainCharts'))
        },()=>{
            this.getZchartsDate()
        })
        let res=await chartData({source: 0})
        if(res.code==0){
            this.setState({
               datas:res.data 
            })
            this.setState({
                chartData1:[{
                    name: '影楼',
                    value:res.data.todayStudioOrderQuantity,
                   
                },
                {
                    name: '工厂',
                    value:res.data.todayFactoryOrderQuantity,
                    
                }],
                chartData2:[{
                    name: '影楼',
                    value:res.data.todayStudioOrderAmount,
                    
                },
                {
                    name: '工厂',
                    value:res.data.todayFactoryOrderAmount,
                   
                }]
            },()=>{
                this.chartsSet("myChart1",this.state.chartData1,res.data.todayQuantity,'下单总本数')
                this.chartsSet("myChart2",this.state.chartData2,res.data.todayAmount,'下单总金额')
            })
             
            
        }else{
            Toast.fail(res.msg,3)
        }
        
        
    }
}